import { useState } from 'react';

const useModalState = (initialData = null) => {
    const [isOpen, setIsOpen] = useState(false);
    const [data, setData] = useState(initialData);

    const openModal = (modalData = null) => {
        if (modalData) {
            setData(modalData);
        }
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setData(null);
    };

    const updateModalData = (newData) => {
        setData(prev => ({
            ...prev,
            ...newData
        }));
    };

    const resetModalData = () => {
        setData(initialData);
    };

    const setModalData = (newData) => {
        setData(newData);
    };

    return {
        isOpen,
        data,
        openModal,
        closeModal,
        updateModalData,
        resetModalData,
        setModalData
    };
};

export default useModalState;
